(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.controller.core
  (:require
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.controller.debt-financing
    :refer [->debt-financing]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.controller.details-and-figures
    :refer [->details-and-figures]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.controller.financial-statements
    :refer [->financial-statements]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.controller.overview :as
    overview-ctl]
   [frontend.ui.component.lp-portal.report.tearsheet.largest-investments-at-fair-value.controller
    :refer [largest-investments-by-nav]]
   [frontend.ui.component.lp-portal.report.tearsheet.portfolio-locations.controller
    :refer [portfolio-locations]]
   [frontend.ui.component.lp-portal.report.tearsheet.return-development.controller
    :refer [tvpi]]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.common.controller :as re]))

(defn- tearsheet
  [{:keys [dynamic-path dynamic-data report-data map-topo] :as props}]
  {:tvpi (report-ctl/with-footnote
          props
          :tvpi-footnotes
          (tvpi (get-in report-data [:tearsheet :tvpi])
                {}))
   :return-development (report-ctl/with-footnote
                        props
                        :return-development-footnotes
                        (get-in report-data [:tearsheet :return-development]))
   :largest-investment-by-nav (report-ctl/with-footnote
                               props
                               :largest-investments-footnotes
                               (largest-investments-by-nav
                                (get-in report-data [:tearsheet :nav-by-properties])))
   :portfolio-locations (report-ctl/with-footnote
                         props
                         :portfolio-locations-footnotes
                         (portfolio-locations map-topo (get-in report-data [:chart-data-map])))
   :basic-information-primary (report-ctl/with-footnote
                               props
                               :basic-information-primary-footnotes
                               (get-in report-data
                                       [:basic-information-primary]))
   :basic-information-secondary (report-ctl/with-footnote
                                 props
                                 :basic-information-secondary-footnotes

                                 (get-in report-data [:basic-information-secondary]))})

(defn ->ui-data
  [{:keys [dynamic-data report-data] :as props}]
  {:fund-name      (:fund-name report-data)
   :reference-date (:reference-date report-data)
   :tearsheet      (tearsheet (update props :dynamic-path concat [:tearsheet]))
   :overview       (overview-ctl/->overview (update props :dynamic-path concat [:overview]))
   :esg            (re/esg (update props :dynamic-path concat [:esg]))
   :debt-financing (->debt-financing (update props :dynamic-path concat [:debt-financing]))
   :details-and-figures (->details-and-figures
                         (update props :dynamic-path concat [:details-and-figures]))
   :financial-statements (->financial-statements
                          (update props :dynamic-path concat [:financial-statements]))})
